import React from 'react';
import { Link } from 'react-router-dom';
import VideoModal from '../ModalVideo/VideoModal';

// image
import Himg1 from '../../images/forinvestorhero.webp'
import Hshape from '../../images/slider/shape.svg'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const hero = () => {
    return (
        <section className="hero_section">
            <div className="bg_shape">
                <svg viewBox="0 0 1920 1075" fill="none">
                    <path d="M0 0H1920V1000C1920 1000 1632 619 962 917C292 1215 0 1000 0 1000V0Z" fill="#E6F8EE" />
                </svg>
            </div>
            <div className="content">
                <h2>For Investors</h2>
                <h3>Strategic Investment in Healthcare Infrastructure</h3>
                <p>Capitalize on the growing pharmacy sector through our proven acquisition and optimization strategy. We deliver attractive returns by transforming independent pharmacies into high-performing healthcare assets.
                </p>
                <a href="https://portal.pharmacyfreedomfund.com/" className="theme-btn">Invest Now</a>
            </div>
            <div className="image_content">

                <div className="image">
                    <img src={Himg1} alt="" />
                    <div className="bg_shape_2">
                        <img src={Hshape} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default hero;